module.exports = __webpack_public_path__ + "static/media/KRTL_logo.bed45942.svg";